var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import SearchMeetingsFilters from '@web/components/Apps/SearchMeetings/SearchMeetingsFilters';
import SearchMeetingsTable from '@web/components/Apps/SearchMeetings/SearchMeetingsTable';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
function pickMeetSearchSnapshot(f) {
    return {
        title: f.title,
        user: f.user,
        orgUnit: f.orgUnit,
        period: f.period,
        dateFrom: f.dateFrom,
        dateTo: f.dateTo,
        meetingType: f.meetingType,
        meetingDurationType: f.meetingDurationType,
        durationHours: f.durationHours,
        durationMinutes: f.durationMinutes,
        meetingParticipantsType: f.meetingParticipantsType
    };
}
export function SearchMeetings() {
    var _a;
    var t = useTranslation().t;
    var currentFilters = useFilters();
    var navigateTo = useNavigateTo();
    var location = useLocation();
    var _b = useState(function () {
        return currentFilters.hasInitialSearch
            ? pickMeetSearchSnapshot(currentFilters)
            : null;
    }), searchSnapshot = _b[0], setSearchSnapshot = _b[1];
    var _c = useState(currentFilters.hasInitialSearch || false), hasInitialSearch = _c[0], setHasInitialSearch = _c[1];
    useEffect(function () {
        setHasInitialSearch(currentFilters.hasInitialSearch || false);
    }, [currentFilters.hasInitialSearch]);
    var handleSearch = function () {
        setSearchSnapshot(pickMeetSearchSnapshot(currentFilters));
        setHasInitialSearch(true);
        navigateTo({
            pathname: location.pathname,
            newFilters: {
                hasInitialSearch: true
            }
        });
    };
    var filtersForQuery = searchSnapshot === null
        ? currentFilters
        : __assign(__assign(__assign({}, currentFilters), searchSnapshot), { page: currentFilters.page });
    return (_jsxs(_Fragment, { children: [_jsxs("h2", __assign({ className: "flex items-center text-xl leading-7 font-semibold gap-1" }, { children: [_jsx("img", { src: "https://staging.workalizer.com/assets/img/email_icons/google-meet-icon.png", alt: "Google Meet", width: 32, height: 32 }), t('app.apps.searchMeetings.meetAdvancedSearch')] })), _jsx(SearchMeetingsFilters, { onSearch: handleSearch }), hasInitialSearch && searchSnapshot !== null && (_jsx(SearchMeetingsTable, { filters: filtersForQuery, page: (_a = currentFilters.page) !== null && _a !== void 0 ? _a : 1 }))] }));
}
export default SearchMeetings;
